import React, { useEffect, useState } from "react";
import {
    deleteDocument,
    generateCustomID,
    saveData,
    uniqueID,
    uploadImage,
} from "../../../firebase/utility";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
const useSubCategoryHook = () => {
    const { all_subCategories } = useSelector((state) => state.redux);
    const { user } = useSelector((state) => state.auth);

    const [allSubCategories, setAllSubCategories] = useState(all_subCategories ?? []);

    const [duplicateSubCategories, setDuplicateSubCategories] = useState(all_subCategories ?? []);
    const [modal, setModal] = useState(false);
    const [selectedSubCategory, setSelectedSubCategory] = useState(null);
    const [searchValue, setSearchValue] = useState(localStorage.getItem("subCategorySearch") || "");
    const [canSearch, setCanSearch] = useState(!!localStorage.getItem("subCategorySearch"));

    // Function to handle search data
    const handleOnSearchData = () => {
        let text = searchValue.trim();
        let filteredSubCategories = [...duplicateSubCategories];
        if (text?.length > 0) {
            filteredSubCategories = filteredSubCategories.filter((item) => {
                const search = `${item?.id} ${item?.subCategoryName} `;
                const searchUserQuery = search.toUpperCase();
                const textData = text.toUpperCase();
                return searchUserQuery.indexOf(textData) > -1;
            });
        }
        setAllSubCategories(filteredSubCategories);
    };
    const handleNewCategoryModal = () => {
        setModal(true);

    };
    const onClose = () => {
        setModal(false);
        setSelectedSubCategory(null)
    };

    const onSubmit = async (formData, resetForm, setLoading) => {
        try {
            setLoading(true);
            const _id = selectedSubCategory?._id ?? uniqueID();
            let imageUrl = formData.subCategoryImage;

            if (imageUrl && typeof imageUrl === "object") {
                imageUrl = await uploadImage(
                    formData.subCategoryImage,
                    "SubCategoryImages"
                );
            }

            const subCategoryData = {
                _id,
                subCategoryName: formData.subCategoryName,
                categoryId: formData.categoryId,
                subCategoryImageURL: formData?.subCategoryImageURL ?? "",
                subCategoryImage: imageUrl || null,
                id: selectedSubCategory?.id ?? (await generateCustomID("SubCategories")),
            };
            if (selectedSubCategory?._id) {
                subCategoryData.updatedAt = Date.parse(new Date());
                subCategoryData.updatedBy = { _id: user?._id || "", username: user?.username || "", email: user?.email || "" };
                subCategoryData.createdAt = selectedSubCategory?.createdAt ?? null;
                subCategoryData.createdBy = selectedSubCategory?.createdBy ?? null;
            } else {
                subCategoryData.createdAt = Date.parse(new Date());
                subCategoryData.createdBy = { _id: user?._id || "", username: user?.username || "", email: user?.email || "" };
            }

            const result = await saveData("SubCategories", _id, subCategoryData);
            if (result) {
                toast.success(
                    `${formData.subCategoryName} SubCategory Saved successfully.`
                );
                resetForm();
                handleNewCategoryModal();
            } else {
                toast.error("Failed to save subcategory.");
            }
        } catch (err) {
            toast.error("An error occurred. Please try again.");
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = (id) => {
        if (id) {
            deleteDocument("SubCategories", id).then(() => {
                toast.success(`Sub Category Deleted Successfully`);
            });
        }
    };



    useEffect(() => {
        if (canSearch) {
            localStorage.setItem("subCategorySearch", searchValue);
        }
        const delayDebounceFn = setTimeout(() => {
            if (canSearch || searchValue.length > 0) {
                handleOnSearchData();
            }
        }, 1000);
        return () => clearTimeout(delayDebounceFn);
    }, [searchValue, canSearch, duplicateSubCategories]);

    useEffect(() => {
        if (all_subCategories?.length > 0) {
            setAllSubCategories(all_subCategories ?? []);
            setDuplicateSubCategories(all_subCategories ?? [])
        }
    }, [all_subCategories]);
    return {
        allSubCategories,
        setAllSubCategories,
        modal,
        setModal,
        selectedSubCategory,
        setSelectedSubCategory,
        onSubmit,
        handleDelete,
        handleNewCategoryModal,
        onClose,
        setSearchValue,
        searchValue,
        canSearch, setCanSearch
    };
};

export default useSubCategoryHook;
